import { render, staticRenderFns } from "./SampleBlob.vue?vue&type=template&id=06b993f9&scoped=true&lang=html&"
import script from "./SampleBlob.vue?vue&type=script&lang=js&"
export * from "./SampleBlob.vue?vue&type=script&lang=js&"
import style0 from "./SampleBlob.vue?vue&type=style&index=0&id=06b993f9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b993f9",
  null
  
)

export default component.exports